const sliderHolder = document.querySelector(
  '[data-label="custom-slider-holder"]'
);
const rangeButtons = document.querySelectorAll('[data-type="range-slider"]');
const rightRangeSlider = document.querySelector(".facets__input-slider--right");
const leftRangeSlider = document.querySelector(".facets__input-slider--left");

const rightNumberInput = document.querySelector(".field__custom-input--right");
const leftNumberInput = document.querySelector(".field__custom-input--left");

const sliderMobileHolder = document.querySelector(
  '[data-label="custom-mobile-slider-holder"]'
);

const rangeMobileButtons = document.querySelectorAll(
  '[data-type="mobile-range-slider"]'
);
const rightMobileRangeSlider = document.querySelector(
  ".facets__input-mobile-slider--right"
);
const leftMobileRangeSlider = document.querySelector(
  ".facets__input-mobile-slider--left"
);

const rightMobileNumberInput = document.querySelector(
  ".field__custom-mobile-input--right"
);
const leftMobileNumberInput = document.querySelector(
  ".field__custom-mobile-input--left"
);

function sliderHolderSetProperty(property, type, value) {
  if (type === "desktop ") {
    if (property === "right") {
      sliderHolder.style.setProperty(
        "--right-x",
        `${100 - (value / +rightRangeSlider.max) * 100}%`
      );
    } else if (property === "left") {
      sliderHolder.style.setProperty(
        "--left-x",
        `${(value / +rightRangeSlider.max) * 100}%`
      );
    } else {
      return;
    }
  } else if (type === "mobile") {
    if (property === "right") {
      sliderMobileHolder.style.setProperty(
        "--right-x",
        `${100 - (value / +rightMobileRangeSlider.max) * 100}%`
      );
    } else if (property === "left") {
      sliderMobileHolder.style.setProperty(
        "--left-x",
        `${(value / +rightMobileRangeSlider.max) * 100}%`
      );
    } else {
      return;
    }
  } else {
    return;
  }
}
sliderHolderSetProperty("left", "desktop", leftRangeSlider.value);
sliderHolderSetProperty("right", "desktop", rightRangeSlider.value);
sliderHolderSetProperty("left", "mobile", leftMobileRangeSlider.value);
sliderHolderSetProperty("right", "mobile", rightMobileRangeSlider.value);

// handling right range slider on dektop
rightRangeSlider.addEventListener("input", function () {
  rightNumberInput.value = this.value;

  sliderHolderSetProperty("right", "desktop", this.value);
  if (+this.value < +leftRangeSlider.value) {
    this.value = +leftRangeSlider.value;
    rightNumberInput.value = this.value;
    sliderHolderSetProperty("right", "desktop", this.value);
  }
});

// handling right range slider on mobile
rightMobileRangeSlider.addEventListener("input", function () {
  rightMobileNumberInput.value = this.value;

  sliderHolderSetProperty("right", "mobile", this.value);
  if (+this.value < +leftMobileRangeSlider.value) {
    this.value = +leftMobileRangeSlider.value;
    rightMobileNumberInput.value = this.value;
    sliderHolderSetProperty("right", "mobile", this.value);
  }
});

// hadnling lefr range slider button desktop
leftRangeSlider.addEventListener("input", function () {
  leftNumberInput.value = this.value;
  sliderHolderSetProperty("left", "desktop", this.value);
  if (+this.value > +rightRangeSlider.value) {
    this.value = +rightRangeSlider.value;
    leftNumberInput.value = this.value;
    sliderHolderSetProperty("left", "desktop", +this.value);
  }
});

// hadnling left range slider button mobile
leftMobileRangeSlider.addEventListener("input", function () {
  leftMobileNumberInput.value = this.value;
  sliderHolderSetProperty("left", "mobile", this.value);
  if (+this.value > +rightMobileRangeSlider.value) {
    this.value = +rightMobileRangeSlider.value;
    leftMobileNumberInput.value = this.value;
    sliderHolderSetProperty("left", "mobile", +this.value);
  }
});

/// handling chages on number inputs left desktop
leftNumberInput.addEventListener("input", function () {
  leftRangeSlider.value = +this.value;
  sliderHolderSetProperty("left", "mobile", +this.value);
});
/// handling chages on number inputs left mobile

leftMobileNumberInput.addEventListener("input", function () {
  leftMobileRangeSlider.value = +this.value;
  sliderHolderSetProperty("left", "mobile", +this.value);
});

// handling right number innput desktop
rightNumberInput.addEventListener("input", function () {
  rightRangeSlider.value = +this.value;
  sliderHolderSetProperty("right", "desktop" + this.value);
});

// handling right number innput desktop
rightMobileNumberInput.addEventListener("input", function () {
  rightMobileRangeSlider.value = +this.value;
  sliderHolderSetProperty("right", "mobile", +this.value);
});
